/**
 * SOSButton — Botão de emergência flutuante
 * Aparece durante corridas ativas (passageiro e motorista)
 * Oferece: Polícia (190), SAMU (192), Bombeiros (193) e compartilhar localização
 */
import React, { useState } from "react";

const EMERGENCIAS = [
  { numero: "190", label: "Polícia", emoji: "🚔", cor: "#3b82f6" },
  { numero: "192", label: "SAMU", emoji: "🚑", cor: "#ef4444" },
  { numero: "193", label: "Bombeiros", emoji: "🚒", cor: "#f97316" },
  { numero: "197", label: "Polícia Civil", emoji: "🔵", cor: "#6366f1" },
];

export default function SOSButton({ rideId, userType, lat, lng }) {
  const [aberto, setAberto] = useState(false);
  const [compartilhado, setCompartilhado] = useState(false);

  const ligar = (numero) => {
    window.location.href = `tel:${numero}`;
    setAberto(false);
  };

  const compartilharLocalizacao = async () => {
    const url = lat && lng
      ? `https://maps.google.com/maps?q=${lat},${lng}`
      : "Localização não disponível";
    const texto = `🆘 EMERGÊNCIA — corrida Zuno\nLocalização atual: ${url}\nCorrida ID: ${rideId || "—"}`;
    try {
      if (navigator.share) {
        await navigator.share({ title: "SOS Zuno", text: texto });
      } else {
        await navigator.clipboard.writeText(texto);
        setCompartilhado(true);
        setTimeout(() => setCompartilhado(false), 3000);
      }
    } catch (e) {
      try { await navigator.clipboard.writeText(texto); setCompartilhado(true); setTimeout(() => setCompartilhado(false), 3000); } catch {}
    }
    setAberto(false);
  };

  return (
    <>
      <style>{`
        @keyframes sosPulse { 0%,100%{box-shadow:0 0 0 0 rgba(239,68,68,0.7)} 50%{box-shadow:0 0 0 10px rgba(239,68,68,0)} }
        @keyframes sosSlideUp { from{opacity:0;transform:translateY(12px)} to{opacity:1;transform:translateY(0)} }
      `}</style>

      {/* Overlay escuro quando aberto */}
      {aberto && (
        <div
          onClick={() => setAberto(false)}
          style={{ position:"fixed",inset:0,zIndex:99990,background:"rgba(0,0,0,0.6)",backdropFilter:"blur(4px)" }}
        />
      )}

      {/* Painel de emergência */}
      {aberto && (
        <div style={{
          position:"fixed", bottom:80, left:"50%", transform:"translateX(-50%)",
          width:"calc(100% - 32px)", maxWidth:440, zIndex:99999,
          background:"linear-gradient(160deg,#1a0000,#0d1527)",
          borderRadius:24, padding:"20px 20px 24px",
          border:"1px solid rgba(239,68,68,0.35)",
          boxShadow:"0 8px 40px rgba(239,68,68,0.25)",
          animation:"sosSlideUp 0.25s ease",
        }}>
          {/* Handle + título */}
          <div style={{ width:36,height:4,background:"rgba(255,255,255,0.12)",borderRadius:2,margin:"0 auto 16px" }} />
          <div style={{ display:"flex",alignItems:"center",gap:10,marginBottom:18 }}>
            <div style={{ width:36,height:36,borderRadius:"50%",background:"rgba(239,68,68,0.15)",border:"1px solid rgba(239,68,68,0.4)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18 }}>🆘</div>
            <div>
              <p style={{ color:"#fff",fontWeight:800,fontSize:15,margin:0 }}>Emergência</p>
              <p style={{ color:"rgba(255,255,255,0.4)",fontSize:11,margin:0 }}>Toque para ligar diretamente</p>
            </div>
          </div>

          {/* Botões de emergência */}
          <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14 }}>
            {EMERGENCIAS.map(({ numero, label, emoji, cor }) => (
              <button
                key={numero}
                onClick={() => ligar(numero)}
                style={{
                  padding:"14px 12px", borderRadius:16, border:`1px solid ${cor}44`,
                  background:`${cor}18`, cursor:"pointer", fontFamily:"inherit",
                  display:"flex", flexDirection:"column", alignItems:"center", gap:4,
                  transition:"all 0.15s",
                }}
              >
                <span style={{ fontSize:24 }}>{emoji}</span>
                <p style={{ color:"#fff",fontWeight:700,fontSize:14,margin:0 }}>{numero}</p>
                <p style={{ color:cor,fontSize:11,fontWeight:600,margin:0 }}>{label}</p>
              </button>
            ))}
          </div>

          {/* Compartilhar localização */}
          <button
            onClick={compartilharLocalizacao}
            style={{
              width:"100%", padding:"13px", borderRadius:14,
              border:"1px solid rgba(168,85,247,0.3)",
              background:"rgba(168,85,247,0.1)",
              color:"#a855f7", fontSize:14, fontWeight:700,
              cursor:"pointer", fontFamily:"inherit",
              display:"flex", alignItems:"center", justifyContent:"center", gap:8,
            }}
          >
            {compartilhado ? "✓ Localização copiada!" : "📍 Compartilhar minha localização"}
          </button>
        </div>
      )}

      {/* Botão SOS flutuante */}
      <button
        onClick={() => setAberto(p => !p)}
        style={{
          position:"fixed",
          bottom: userType === "driver" ? 140 : 88,
          right:16,
          zIndex:9990,
          width:48, height:48,
          borderRadius:"50%",
          border:"2px solid rgba(239,68,68,0.8)",
          background: aberto ? "rgba(239,68,68,0.9)" : "rgba(239,68,68,0.18)",
          backdropFilter:"blur(8px)",
          color: aberto ? "#fff" : "#ef4444",
          fontSize:13, fontWeight:900, letterSpacing:0.5,
          cursor:"pointer", fontFamily:"inherit",
          animation: aberto ? "none" : "sosPulse 2s ease-in-out infinite",
          transition:"all 0.2s",
          display:"flex", alignItems:"center", justifyContent:"center",
        }}
        aria-label="SOS Emergência"
      >
        SOS
      </button>
    </>
  );
}
